// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"0ab7a2b7","909":"7567cb4b"}[chunkId] + ".chunk.css";
};